import { isUnauthorizedError, Attribution } from '@confluence/error-boundary';
import { markErrorAsHandled } from '@confluence/graphql';
import { getMonitoringClient } from '@confluence/monitoring';
import { containsNoNetworkError } from '@confluence/network';

import type { BreadcrumbsType } from './useEditorBreadcrumbs';
import type { EditorBreadcrumbsQuery as EditorBreadcrumbsQueryType } from './__types__/EditorBreadcrumbsQuery';

export function handleEditorBreadcrumbsQueryResult(
	data: EditorBreadcrumbsQueryType | undefined,
	error: Error | undefined,
): BreadcrumbsType {
	if (error) {
		if (containsNoNetworkError(error) || isUnauthorizedError(error)) {
			markErrorAsHandled(error);
		} else {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.PAGE_MODES,
			});
		}
	}

	return (data?.experimentalEditorBreadcrumbs?.breadcrumbs || []) as BreadcrumbsType;
}
